<template>
    <div class="table-responsive tabelageralnew">
        <loading :show="show" :label="label" :overlay="overlay"></loading>
        <div class="barra_botoes_exportar">
            <span class="titulo_btnexport">Exportar para: </span>
            <download-excel class="btn_exportnew"
            :title="tituloexport"
            :fetch="fetchData"
            :fields="dadostitulo"
            :name="nomearquivo+'.xls'">
                <img alt="Exportar para xls" title=".xls" src="../../../assets/images/icon_xls.png">
            </download-excel>
            <download-excel class="btn_exportnew"
            :title="tituloexport"
            :fetch="fetchData"
            :fields="dadostitulo"
            type="csv"
            :name="nomearquivo+'.csv'">
                <img alt="Exportar para csv" title=".csv" src="../../../assets/images/icon_csv.png">
            </download-excel>
            <download-excel class="btn_exportnew"
            :title="tituloexport"
            :fetch="fetchData"
            :fields="dadostitulo"
            :name="nomearquivo+'.doc'">
                <img alt="Exportar para dpc" title=".doc" src="../../../assets/images/icon_doc.png">
            </download-excel>
            <div class="btn_exportnew"><a v-on:click="exportarpdf()">
                <img alt="Exportar para pdf" title=".pdf" src="../../../assets/images/icon_pdf.png">
            </a></div>
        </div>
        <table class="table table-striped">
            <thead class="">
                <tr>
                    <th width="85px" style="vertical-align: top !important;">Mês/Ano</th>
                    <th>Súmula</th>
                    <th width="113px" style="text-align:center !important;">Diário Oficial</th>
                    <th width="113px" style="text-align:center !important;">Data Diário</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="itens in dadosconteudo.tr">
                    <td v-if="itens.data != ''" :rowspan="itens.rowspan" style="vertical-align: top !important;">       {{itens.data}}
                    </td>
                    <td><a :href="itens.download" target="_blank">{{itens.sumula}}</a></td>
                    <td style="text-align:center !important;"><a :href="itens.linkdiario" target="_blank">{{{itens.diario}}}</a></td>
                    <td style="text-align:center !important;">{{itens.datadiario}}</td>
                </tr>
            </tbody>
        </table>

        <div class="text-center">
            <cp-paginate :source="dadosconteudo" @navigate="navigate"><cp-paginate>
                    </div>
                    </div>
                    <!-- <div class="table-responsive">
                        <table class="table table-bordered table-striped table-condensed">
                            <thead class="">
                                <tr>
                                    <th> Processo </th>
                                    <th> Modalidade/Nº </th>
                                    <th class="numeric"> Fase </th>
                                    <th class="numeric"> Objeto </th>
                                    <th class="numeric"> </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td> 000001/2017 </td>
                                    <td>Pregão Presencial PP001/2017</td>
                                    <td class="numeric">30/01/2017 Aviso de Prorrogação</td>
                                    <td class="numeric">Contratação de empresa especializada para o Fornecimento de Combustíveis, Óleo Lubrificante e Filtro de Combustíveis, destinado ao abastecimento dos veículos e máquinas da frota, própria e locada, da Prefeitura Municipal de Aporá, durante o ano de 2017.</td>
                                    <td class="numeric"><i class="fa fa-download"></i></td>
                                </tr>                        
                                <tr>
                                    <td rowspan="3"> 000332/2016 </td>
                                    <td> Convite CC009/2016</td>
                                    <td class="numeric"> 04/01/2017 Extrato de Homologação</td>
                                    <td class="numeric"> Contratação de Sociedade Empresária especializada em Serviços de Locação com montagem, desmontagem e instalação de equipamentos de Estrutura de Palco, Som, Iluminação, Geradores, Elevações de Alumínio, Sanitários Químicos, Camarim e Toldos, para a formação da Estrutura da Festa de Santo Reis, no Distrito de Itamira neste município, no dia 06 de Janeiro do ano 2017. </td>
                                    <td class="numeric"><i class="fa fa-download"></i></td>
                                </tr>
                            </tbody>
                        </table>
                    </div> -->
                    </template>
                    <script>
                        import CpPaginate from '../../pagination/pagination.vue'
                        import downloadExcel from 'vue-json-excel'
                        import loading from 'vue-full-loading'

                                export default{
                                    data() {
                                        return { 
                                            dadostable: {},
                                            nomearquivo: '',
                                            tituloexport: '',
                                            dadosexportar: {},
                                            dadostitulo: {
                                                'Mês/Ano': 'data',
                                                'Súmula': 'sumula',
                                                'Download Súmula': {
                                                    'field': 'download',
                                                    'callback': (value) => {
                                                       return `<a href="${value}">Download</a>`
                                                    }
                                                },
                                                'Diário Oficial': 'diario',
                                                'Download Diario': {
                                                    'field': 'linkdiario',
                                                    'callback': (value) => {
                                                       return `<a href="${value}">Download</a>`
                                                    }
                                                },
                                                'Data Diário': 'datadiario'
                                            },
                                            json_meta: [
                                                [
                                                    {
                                                        'key': 'charset',
                                                        'value': 'utf-8'
                                                    }
                                                ]
                                            ],
                                            show: false,
                                            label: 'Gerando arquivo...',
                                            overlay: true, 
                                        }
                                    },
                                    props: ['dadosconteudo'],
                                    components: {
                                        CpPaginate, downloadExcel, loading
                                    },
                                    ready() {
                                        $('.table-responsive').fadeOut('fast');
                                    },
                                    watch: {
                                        $route() {
                                            $('.table-responsive').fadeOut('fast');
                                        }
                                    },
                                    methods: {
                                        fetchData(){
                                            $.ajaxSetup({
                                                async: false
                                            });
                                            //this.show = true;
                                            var self = this
                                            var page = '-1'
                                            MPL.loadDadosLegislacao(page, function (dados)
                                            {
                                                
                                                self.dadosexportar = dados[0].tr
                                                
                                                    
                                            });

                                            $.ajaxSetup({
                                                async: true
                                            });

                                            //console.log(window.dadosconteudogeral)
                                            this.tituloexport = window.dadosconteudogeral.titulopagina
                                            var tit = this.tituloexport[0]
                                            tit = tit.split(/\s*\\s*/)
                                            tit = tit[0].replace(/\s/g,"")
                                            this.nomearquivo = tit
                                            //console.log(tit)
                                            //this.show = false;
                                            return self.dadosexportar
                                        },
                                        exportarpdf () {
                                            this.show = true
                                            // $.ajaxSetup({
                                            //     async: false
                                            // });

                                            var exportpdf
                                            var self = this
                                            var page = '-1'
                                            MPL.loadDadosLegislacao(page, function (dados)
                                            {
                                                exportpdf = dados[0].tr

                                                var colunas = [
                                                    {title: 'Mês/Ano', dataKey: 'data'},
                                                    {title: 'Súmula', dataKey: 'sumula'},
                                                    {title: 'Diário Oficial', dataKey: 'diario'},
                                                    {title: 'Data Diário', dataKey: 'datadiario'}
                                                ]

                                                var doc = new jsPDF('l', 'pt')
                                                
                                                var titulopdf = window.dadosconteudogeral.titulopagina
                                                var tit = titulopdf[0]
                                                tit = tit.split(/\s*\\s*/)
                                                tit = tit[0].replace(/\s/g,"")
                                                self.nomearquivo = tit
                                                
                                                doc.autoTable(colunas, exportpdf, {
                                                    styles: {overflow: 'linebreak'},
                                                    columnStyles: {
                                                        data: {columnWidth: 60},
                                                        diario: {columnWidth: 75, halign: 'center'},
                                                        datadiario: {columnWidth: 70, halign: 'center'},
                                                    },
                                                    addPageContent: function(data) {
                                                        doc.text(titulopdf, 40, 30);
                                                    }
                                                })
                                                
                                                doc.save(self.nomearquivo+'.pdf')
                                                //console.log('teste')
                                                self.show = false
                                            });

                                            // $.ajaxSetup({
                                            //     async: true
                                            // });
                                            //console.dir(exportpdf)
                                        },
                                        navigate(page) {
                                            $.ajaxSetup({
                                                async: false
                                            });

                                            var self = this
                                            //alert('disparando navegacao');
                                            if (this.$route.params.tipo == 'legislacao') {

                                                MPL.loadDadosLegislacao(page, function (dados)
                                                {
                                                    self.dadosconteudo = dados[0];
                                                    self.dadostable = dados[0];
                                                });

                                            }
                                            if (this.$route.params.tipo == 'diarias') {
                                                $.getJSON('./src/components/tables/table-t5/datatable2v2.json', function (dados)
                                                {
                                                    //self.dadosconteudo = dados[0];
                                                    self.dadosconteudo = dados[0];
                                                    self.dadostable = dados[0];
                                                    //alert(self.$route.params.tipo)
                                                    //console.log(dados[0].conteudo)
                                                });
                                            }

                                            $.ajaxSetup({
                                                async: true
                                            });

                                        }
                                    }
                                }
                    </script>



// WEBPACK FOOTER //
// table.vue?b6000af6